import React from 'react';

class CardContainerComponent extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const {children, disablePadding} = this.props;

        return (
            <div className="card card-style">
                <div className={disablePadding ? '' : 'content pb-2'}>
                    {children}
                </div>
            </div>
        );
    }
}

export default CardContainerComponent;